
define('ldsh!templates/alert', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="notification alert alert-' +
__e(type) +
'">\n    <i class="fa ' +
__e(icon) +
'"></i>\n    <div class="i18n" data-i18n="' +
((__t = (msg)) == null ? '' : __t) +
'"></div>\n    <div>' +
((__t = (msg_lang)) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
};});

